import HomeHero from "./components/HomeHero";
import HomeCategories from "./components/HomeCategories";
import HomeFeatured from "./components/HomeFeatured";
import HomeLatest from "./components/HomeLatest";
import HomeFAQ from "./components/HomeFAQ";
import HomeCTA from "./components/HomeCTA";

export default function Home() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "糖果直播",
    url: "https://tangguolive.com",
    description: "糖果直播 - 直播资讯与内容平台，提供最新直播资讯、栏目推荐、使用教程与平台动态",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://tangguolive.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  const orgJsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "糖果直播",
    url: "https://tangguolive.com",
    description: "糖果直播致力于为用户提供最新、最全的直播资讯和内容服务",
    sameAs: [
      "https://weibo.com/tangguolive",
      "https://www.zhihu.com/org/tangguolive",
    ],
  };

  return (
    <>
      <title>糖果直播 - 直播资讯与内容平台 | 在线观看指南</title>
      <meta
        name="description"
        content="糖果直播为您提供最新直播资讯、精选栏目推荐、实用教程指南与平台动态。涵盖直播行业趋势、热门栏目盘点、设备选购指南、直播技巧分享等内容，为用户提供便捷清晰的直播内容参考。"
      />
      <meta
        name="keywords"
        content="糖果直播,直播,在线观看,节目资讯,平台动态,直播教程,直播栏目,直播行业"
      />
      <link rel="canonical" href="https://tangguolive.com" />

      <meta property="og:type" content="website" />
      <meta property="og:title" content="糖果直播 - 直播资讯与内容平台 | 在线观看指南" />
      <meta
        property="og:description"
        content="糖果直播为您提供最新直播资讯、精选栏目推荐、实用教程指南与平台动态。"
      />
      <meta property="og:url" content="https://tangguolive.com" />
      <meta property="og:site_name" content="糖果直播" />
      <meta property="og:locale" content="zh_CN" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="糖果直播 - 直播资讯与内容平台" />
      <meta
        name="twitter:description"
        content="糖果直播为您提供最新直播资讯、精选栏目推荐、实用教程指南与平台动态。"
      />

      <meta name="geo.region" content="CN" />
      <meta name="geo.placename" content="中国" />

      <script type="application/ld+json">
        {JSON.stringify(jsonLd)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(orgJsonLd)}
      </script>

      <HomeHero />
      <HomeCategories />
      <HomeFeatured />
      <HomeLatest />
      <HomeFAQ />
      <HomeCTA />
    </>
  );
}